<template>
  <t-section header="Próximos Eventos" icon="mdi-calendar-check-outline">
    <template #input>
      <v-col cols="12" md="3">
        <t-select
          :items="categories"
          item-text="title"
          item-value="id"
          return-object
          with-icons
          background-color="transparent"
          dense
          hide-details
          label="Filtrar Categoria"
          @change="($event) => fetch(1, $event.id)"
        />
      </v-col>
    </template>
    <t-container>
      <v-row v-if="events.length > 0" justify="center" class="py-8">
        <v-col
          v-for="(event, index) in events"
          :key="index"
          cols="12"
          md="6"
          lg="4"
          class="d-flex align-items-stretch"
        >
          <t-event-card :event="event" />
        </v-col>
      </v-row>
      <v-row v-else class="d-flex flex-column dynamic-font-size fill-height mb-4 pt-8 px-2">
        <v-icon size="60">
          mdi-close-circle-outline
        </v-icon>
        <div class="text--secondary text-center">
          Não existem eventos abertos para essa categoria no momento
        </div>
      </v-row>
      <v-row v-if="pageCount > 1" justify="center">
        <v-pagination v-model="page" :length="pageCount" @change="fetch(page)" />
      </v-row>
    </t-container>
  </t-section>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

import TEventCard from "@/components/core/Events/TEventCard.vue";

import getEvents from "@/api/requests/getEvents";

import Event from "@/types/Event";
import Category from "@/types/Category";
import TSelect from "../core/TSelect.vue";
import getCategories from "@/api/requests/getCategories";

export default Vue.extend({
  name: "SectionNextEvents",

  components: {
    TEventCard,
    TSelect,
  },

  props: {
    id: {
      required: false,
      default: "0",
      type: String as PropType<string>,
    },
  },

  data: () => ({
    eventsPerPage: 50,
    page: 1,
  }),

  computed: {
    pageCount(): number {
      return Math.ceil(this.events.length / this.eventsPerPage);
    },
    events(): Event[] {
      return this.$store.state.events.data as Event[];
    },
    categories(): Category[] {
      return this.$store.state.categories.data as Category[];
    },
  },

  mounted() {
    this.fetch();
    this.fetchCategories();
  },

  methods: {
    async fetch(page = 1, category = "") {
      let id = this.$store.state.producers.selected.id as string;

      if (id === "0") id = "";

      const events = (await getEvents(page, id, category)).data.data;

      this.$store.commit("events/setEvents", events);
    },
    async fetchCategories() {
      const categories = await getCategories();

      this.$store.commit("categories/setCategories", categories);
    },
  },
});
</script>
